import HttpClient from './fetch_api';
import { ORDER_PAYMENT } from '../conf/appSetting';

export const paymentInvoice = async (params, gatewayToken) =>
   HttpClient.post(ORDER_PAYMENT.base + ORDER_PAYMENT.invoice, params, {
      Authorization: `Bearer ${gatewayToken}`,
   });
